<template>
  <div class="d-flex flex-column not-found">
    <b-row class="align-items-center flex-column justify-content-center flex-fill">
      <b-col class="text-center align-items-center d-flex flex-column justify-content-end">
        <h1 class="pb-4 not-found-text">404</h1>
        <h4 class="pb-4 not-found-text">{{ 'home.notFound' | translate }}</h4>
        <h4>
          <a class="go-home" href="#" @click="goBack">
            <font-awesome-icon icon="home"/> <span> {{ 'home.goHome' | translate }}</span>
          </a>
        </h4>
      </b-col>
      <b-col class="text-center">
        <img
          alt="Apök"
          src="../assets/images/home/logo.png"
          class="imgLogo w-50"
          :style="{ cursor: 'pointer' }"
          @click="$router.push({name: 'Home'})"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  name: 'NotFoundPage',
  components: { FontAwesomeIcon },
  methods: {
    goBack () {
      this.$router.push({ name: 'Home' })
    },
  },
}
</script>

<style scoped lang='scss'>
.not-found {
  min-height: 100vh;
  background-color: #e6e6e6;
}

h4 {
  color: #23729D;

}

h1 {
  font-weight: 600;
  color: #EC8409;
}
  .go-home {
    color: #EC8409;

    &:hover {
      cursor: pointer;
      text-decoration: none;
      color: #23729D;
    }

  }

  .imgLogo{
    mix-blend-mode: screen;
    max-width: 600px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/NotFoundPage.vue